import { RadiusFilterOption } from '@immosky/types';

export const MINIMUM_RADIUS = 5;

export const availableRadiusOptions: RadiusFilterOption[] = [
  {
    id: '0km',
    text: '+ 0 km',
    value: MINIMUM_RADIUS,
  },
  {
    id: '5km',
    text: '+ 5 km',
    value: 5,
  },
  {
    id: '10km',
    text: '+ 10 km',
    value: 10,
  },
  {
    id: '15km',
    text: '+ 15 km',
    value: 15,
  },
  {
    id: '20km',
    text: '+ 20 km',
    value: 20,
  },
  {
    id: '30km',
    text: '+ 30 km',
    value: 30,
  },
  {
    id: '40km',
    text: '+ 40 km',
    value: 40,
  },
  {
    id: '50km',
    text: '+ 50 km',
    value: 50,
  },
];
